var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.visible,
          expression: "visible",
        },
      ],
      staticClass: "empty-mask",
      class: [_vm.customClass],
      style: { backgroundColor: _vm.background || "" },
    },
    [
      _c("div", { staticClass: "empty-content" }, [
        _vm.iconUrl
          ? _c("img", {
              staticClass: "empty-icon",
              attrs: { src: _vm.iconUrl },
            })
          : _vm._e(),
        _vm._v(" "),
        _vm.showText
          ? _c("p", { staticClass: "empty-text" }, [
              _vm._v(_vm._s(_vm.showText)),
            ])
          : _vm._e(),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }